export default __webpack_public_path__ + "static/happy-travellers-9458d3055349c3b879a5eb9e0e9ff5e6.jpg";